/* eslint-disable @typescript-eslint/indent */
import React, { useContext, useEffect } from 'react';
import MetaDetails from './MetaDetails';
// import DescriptionSections from './DescriptionSections';
import HeroSection from './HeroSection';
import GetConnected from '../common/GetConnected';
import Faq from './Faqs';
import AboutTheCourse from './AboutTheCourse';
// import BlogsAndArticleSection from './BlogsAndArticleSection';
import CounsellorConnectStrip from '../common/LeadCaptureUI/CounsellorConnectStrip';
import { dataLayer } from '../../utils/common/dataLayer.utils';
import CourseDescriptionContext from '../../context/CourseDescriptionContext';
import { getPriceDetails } from '../../utils/helper/helperFunction';
import { LeadCaptureEnquiryType, ModalType } from '../../interfaces/leadCapture.enum';
import OurMentors from '../common/CourseDescriptionPage/OurMentors';
import NavHeaderSection from '../common/CourseDescriptionPage/NavHeaderSection';
import CourseCurriculum from '../common/CourseDescriptionPage/CourseCurriculum';
import ProjectSection from '../common/CourseDescriptionPage/ProjectSection';
import SuccessStories from '../CategoryPage/SucessStories';
import OurAchieversPlacedAt from '../CourseDescriptionPageProfessional/OurAchieversPlacedAt';
import GetCertified from '../common/CourseDescriptionPage/GetCertified';
import AlumniTestimonialTileType from '../common/CourseDescriptionPage/AlumniTestimonialTileType';
import AlumniTestimonialTextType from '../common/CourseDescriptionPage/AlumniTestimonialTextType';
import KeyCourseElements from '../CourseDescriptionPageProfessional/KeyCourseElements';
// import { phoneNumber } from '../CourseDescriptionPageProfessional/CourseCurriculum/constants';

const OnlineDegreeDescriptionPage = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const courseMetaDetails = courseDetails?.courseMetaDetails;

  const DataLayerParam = () => {
    const {
      _id,
      title,
      classTimings,
      categoryIncludingParents,
      pricing,
      ratingAverage,
      programType,
      ratingCount,
    } = courseDetails || {};
    const priceDetails = getPriceDetails(pricing);
    const DataLayerDegreePage = {
      course_id: _id,
      course_name: title,
      course_type: 'online_degree',
      source_page: 'online_degree_page',
      program_type: programType || null,
      domain: (categoryIncludingParents && categoryIncludingParents[0]?.title) || null,
      language: courseMetaDetails?.overview?.language || null,
      amount: priceDetails?.currentPrice || null,
      discountPercent: priceDetails?.discount || null,
      start_on: classTimings?.startDate || null,
      duration_month: courseMetaDetails?.duration || null,
      course_rating: ratingAverage || null,
      rating_count: ratingCount || null,
      category: (categoryIncludingParents && categoryIncludingParents[1]?.title) || null,
      sub_category: (categoryIncludingParents && categoryIncludingParents[2]?.title) || null,
    };

    dataLayer({
      ...DataLayerDegreePage,
      page_name: 'course_desc',
      event: 'course_desc',
    });
  };

  useEffect(() => {
    DataLayerParam();
  }, []);

  return (
    <div className="relative">
      <NavHeaderSection isCampusEdgeCourseDescription isOnlineDegree />
      <HeroSection />
      <MetaDetails />
      <AboutTheCourse />
      {/* <OnboardingProcess /> */}
      {courseMetaDetails?.enableCourseOffering && <KeyCourseElements />}
      {courseMetaDetails?.enableCurriculum && <CourseCurriculum isAmateur={false} isOnlineDegree />}
      {courseMetaDetails?.enableProjectGallery && <ProjectSection isAmateur={false} />}
      {courseMetaDetails?.enableCourseInstructor && <OurMentors isAmateur={false} />}
      {courseMetaDetails?.enableSuccessStories &&
        courseMetaDetails?.successStories &&
        courseMetaDetails?.successStories?.length > 0 && (
          <div>
            <SuccessStories />
            <OurAchieversPlacedAt />
          </div>
        )}
      {courseMetaDetails?.enableCertificate && <GetCertified isAmateur={false} />}
      {courseMetaDetails?.enableAlumniTestimonials &&
        courseMetaDetails?.testimonials?.length &&
        courseMetaDetails.testimonials.length > 0 && (
          <>
            {courseMetaDetails?.alumniTestimonial?.type === 'TILE' && (
              <AlumniTestimonialTileType isAmateur={false} />
            )}
            {courseMetaDetails?.alumniTestimonial?.type === 'TEXT' && (
              <AlumniTestimonialTextType isAmateur={false} />
            )}
          </>
        )}
      {/* <DescriptionSections /> */}

      {/* need to update value form api */}
      {/* <CertificateSection /> */}

      {/* hidden as per product req */}
      {/* <BlogsAndArticleSection /> */}
      <CounsellorConnectStrip
        enableOnMobile={false}
        phoneNumber="+91 8130166658"
        enquiryType={LeadCaptureEnquiryType.ONLINE_DEGREE_REGISTER_HERE}
        pageName="degree_description"
        enquiryTypeNPF="Online Degree_registerhere"
      />
      <GetConnected
        isConfused={false}
        title="Talk to Our Counsellor"
        subTitle="Get Expert Advice our Counsellor will reach within"
        modalType={ModalType.ONLINE_DEGREE}
        buttonText="Get Connected"
        img="/images/bhilai-lead-capture-modal-pic.svg"
        msgLineOne="We Got Your Response."
        msgLineTwo="Our Counsellor will reach out soon"
        type="ConnectWithCounsellor"
        enquiryType={LeadCaptureEnquiryType.ONLINE_DEGREE_GET_CONNECTED}
        enquiryTypeNPF="Online Degree_getconnected"
        pageName="degree_description"
      />
      <Faq />
    </div>
  );
};

export default OnlineDegreeDescriptionPage;
